// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'BrandonText-Bold';
  src: url('/fonts/BrandonText-Bold.otf') format('opentype');
}
@font-face {
  font-family: 'BrandonText-Black';
  src: url('/fonts/BrandonText-Black.otf') format('opentype');
}
@font-face {
  font-family: 'BrandonText-Medium';
  src: url('/fonts/BrandonText-Medium.otf') format('opentype');
}
@font-face {
  font-family: 'BrandonText-Regular';
  src: url('/fonts/BrandonText-Regular.otf') format('opentype');
}

@font-face {
  font-family: 'ProximaNova-Bold';
  src: url('/fonts/ProximaNova-Bold.otf') format('opentype');
}
@font-face {
  font-family: 'ProximaNova-Semibold';
  src: url('/fonts/ProximaNova-Semibold.otf') format('opentype');
}
@font-face {
  font-family: 'ProximaNova-Light';
  src: url('/fonts/ProximaNova-Light.otf') format('opentype');
}
@font-face {
  font-family: 'ProximaNova-Regular';
  src: url('/fonts/ProximaNova-Regular.otf') format('opentype');
}

#modal-root {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 998;
  display: flex;
  align-items: stretch;
  justify-content: center;
}

#error-modal {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 999;
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.modal-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  width: 100vw;
  height: 100%;
  justify-content: center;
  align-items: stretch;
}

input.visit-input {
  font-family: BrandonText-Medium, Lato, sans-serif;
  font-size: 1.1rem;
  border: none;
}

input.visit-input:focus {
  outline: none;
}

body {
  font-family: Lato, sans-serif;
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.App {
  text-align: center;
}

.App-logo {
  animation: App-logo-spin infinite 6s linear;
  height: 40vmin;
  pointer-events: none;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 8px;
}

.request-id-button {
  width: 100px;
  background-color: #a4d8ea;
}

.request-id-button:hover {
  background-color: #5dd1f8;
  border: none;
  color: black;
}

.custom-modal .ant-modal-header {
  background-color: #DDF3F0;
}

.custom-modal .ant-modal-footer {
  background-color: #DDF3F0;
}

.custom-select .ant-select-selection-item {
  background-color: #008f7b !important;
  color: white !important;
}
.custom-select .ant-select-selector {
  border-color: #008f7b !important;
}

@keyframes App-logo-spin {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,+BAA+B;EAC/B,0DAA0D;AAC5D;AACA;EACE,gCAAgC;EAChC,2DAA2D;AAC7D;AACA;EACE,iCAAiC;EACjC,4DAA4D;AAC9D;AACA;EACE,kCAAkC;EAClC,6DAA6D;AAC/D;;AAEA;EACE,+BAA+B;EAC/B,0DAA0D;AAC5D;AACA;EACE,mCAAmC;EACnC,8DAA8D;AAChE;AACA;EACE,gCAAgC;EAChC,2DAA2D;AAC7D;AACA;EACE,kCAAkC;EAClC,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,iDAAiD;EACjD,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Lato:400,700');\n\n@font-face {\n  font-family: 'BrandonText-Bold';\n  src: url('/fonts/BrandonText-Bold.otf') format('opentype');\n}\n@font-face {\n  font-family: 'BrandonText-Black';\n  src: url('/fonts/BrandonText-Black.otf') format('opentype');\n}\n@font-face {\n  font-family: 'BrandonText-Medium';\n  src: url('/fonts/BrandonText-Medium.otf') format('opentype');\n}\n@font-face {\n  font-family: 'BrandonText-Regular';\n  src: url('/fonts/BrandonText-Regular.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ProximaNova-Bold';\n  src: url('/fonts/ProximaNova-Bold.otf') format('opentype');\n}\n@font-face {\n  font-family: 'ProximaNova-Semibold';\n  src: url('/fonts/ProximaNova-Semibold.otf') format('opentype');\n}\n@font-face {\n  font-family: 'ProximaNova-Light';\n  src: url('/fonts/ProximaNova-Light.otf') format('opentype');\n}\n@font-face {\n  font-family: 'ProximaNova-Regular';\n  src: url('/fonts/ProximaNova-Regular.otf') format('opentype');\n}\n\n#modal-root {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  z-index: 998;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n}\n\n#error-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  z-index: 999;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n}\n\n.modal-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  width: 100vw;\n  height: 100%;\n  justify-content: center;\n  align-items: stretch;\n}\n\ninput.visit-input {\n  font-family: BrandonText-Medium, Lato, sans-serif;\n  font-size: 1.1rem;\n  border: none;\n}\n\ninput.visit-input:focus {\n  outline: none;\n}\n\nbody {\n  font-family: Lato, sans-serif;\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 6s linear;\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.ant-table-thead > tr > th,\n.ant-table-tbody > tr > td {\n  padding: 8px;\n}\n\n.request-id-button {\n  width: 100px;\n  background-color: #a4d8ea;\n}\n\n.request-id-button:hover {\n  background-color: #5dd1f8;\n  border: none;\n  color: black;\n}\n\n.custom-modal .ant-modal-header {\n  background-color: #DDF3F0;\n}\n\n.custom-modal .ant-modal-footer {\n  background-color: #DDF3F0;\n}\n\n.custom-select .ant-select-selection-item {\n  background-color: #008f7b !important;\n  color: white !important;\n}\n.custom-select .ant-select-selector {\n  border-color: #008f7b !important;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotateY(0deg);\n  }\n  to {\n    transform: rotateY(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
